import { Component, h } from "preact"
import LineItem from "./LineItem";
import { Image } from "./Image";
import { debounce } from "debounce";
import { formatMoney } from "@shopify/theme-currency/currency";

class CartPopupItem extends LineItem {
  
  render({item, updateCart}) {
    const {
      key,
      image,
      product_title,
      url,
      product_has_only_default_variant,
      variant_title,
      properties,
      vendor,
      quantity,
      line_price
    } = item;
    console.log(item)
    return (
      <div class="cart-popup__item">
        <div class="row">
          <div class="col-3">
            <a href={ url }>
              <Image src={ image } alt={ product_title } sizes={ ['93x125'] }/>
            </a>
          </div>
          <div class="col-9">
            <div class="cart__product-text position-relative mb-2">
              <a href={ url } class="cart__product-link mb-1">{ product_title }</a>
              <a href="/cart/change?line={{ forloop.index }}&amp;quantity=0" class="cart__remove-btn"
                 onClick={ this.removeItem }>
                <span class="accessibility">{ theme.cart.remove }</span>
              </a>
              { this.renderItemOptions(item) }
              { this.renderItemProperties(properties) }
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row align-items-center">
                  <div class="col-7">
                    <div>
                        <span class="jcf-number">
                          <input id={ `updates_${ key }` }
                                 ref={ c => this.quantityInput = c }
                                 min="0"
                                 onChange={ debounce(this.updateItem, 200) }
                                 value={ this.props.item.quantity }
                                 aria-label={ theme.cart.quantity }
                                 class="jcf-real-element"/>
                          <span class="jcf-btn-inc" onClick={ () => this.changeQuantity('+', this.quantityInput) }/>
                          <span class="jcf-btn-dec" onClick={ () => this.changeQuantity('-', this.quantityInput) }/>
                        </span>
                    </div>
                  </div>
                  <div class="col-5 text-right">{ formatMoney(line_price, theme.moneyFormat) }</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CartPopupItem;
